import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { AuthAPI } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const u = await AuthAPI.me();
      setUser(u);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, skip the /auth/me check
    // and let AuthCallback.jsx exchange the session_id first.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const res = await AuthAPI.login({ email, password });
    setUser(res.user);
    return res.user;
  };

  const register = async (name, email, password, role = 'coach') => {
    const res = await AuthAPI.register({ name, email, password, role });
    setUser(res.user);
    return res.user;
  };

  const logout = async () => {
    try { await AuthAPI.logout(); } catch (_) {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh: checkAuth, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
